<app-list-view [service]="unitsService" [displayedColumns]="['id', 'type']"></app-list-view>
